import { EPiServerGlobal, FormModel } from './form-rendering-service.types'

// This class use ES6 syntax. In case you want to use it in a browser that does not support ES6 syntax (i.e Internet Explorer 11 and below),
// you can copy/paste the render() function to your own script file and replace 'let' keyword with 'var'.
export default {
  render: (formModel, attachNode) => {
    // Initialize form js. Those scripts are used for all forms and only need to execute once, so we check here to make sure
    // when call this method second time, these scripts not execute again.
    if (window.epi == null || window.epi.EPiServer == null || window.epi.EPiServer.Forms == null) {
      // Those eval statements are safe because js strings come from the formModel
      // and formModel comes directly from serverside (not any script can intercept)
      window.eval(formModel.assets.originalJquery)
      window.eval(formModel.assets.jquery)
    }

    // In case form has custom scripts for certain types of element.
    // ex: DateTimeElementBlock inherits from IElementRequireClientResources and so has its own resources
    // Those resources are different for each form so we have to execute the prerequisite script once for each form.
    window.eval(formModel.assets.prerequisite)

    // Inject form's css
    if (!document.getElementById('epiFormCss')) {
      // Inject form's css with id 'epiFormCss'
      let style = document.createElement('style')
      style.type = 'text/css'
      style.id = 'epiFormCss' // Add id to the style
      style.innerHTML = formModel.assets.css
      document.getElementsByTagName('head')[0].appendChild(style)
    }

    // Attach form html template to the attachNode
    let element = typeof attachNode === 'object' ? attachNode : document.getElementById(attachNode)

    // We use jQuery.html() here to allow to execute script embedded inside template of Forms' elements (.ascx files).
    // The form HTML template also contains script of `formModel.assets.formInitScript` so we dont need to explicitly eval formInitScript
    window.jQuery(element).html(formModel.template)

    // Run form initialization script.
    initViewMode(formModel)

    // Adding custom success message to forms with ID "animateSuccess-js"
    initAnimationForm()

    window.jQuery(document).on('DOMSubtreeModified', 'div.Form__Status__Message', function () {
      if (window.jQuery(this).hasClass('Form__Success__Message')) {
        window
          .jQuery(this)
          .parent()
          .append(window.jQuery("<p class='formSuccess'>" + window.jQuery(this).text() + '</p>'))
        window.jQuery(this).addClass('hide')
      }
    })
  },
}

/**
 * This method is a replacement for the original form-rendering-service script:
 *
 *  // Execute form viewmode script. We must set window.epi.EPiServer.Forms.__Initialized = false here otherwise
 *  // in case page has two or more forms, the second form's viewmode script will not be called.
 *  window.epi.EPiServer.Forms.__Initialized = undefined
 *  window.eval(formModel.assets.viewModeJs)
 *
 * FormModel.assets.viewModeJs contains the script text for /Util/EPiServer.Forms/EPiServerForms.min.js (or /Util/EPiServer.Forms/EPiServerForms.js); this script
 * is not intended to be executed multiple times and there are a number of unwanted side effects resulting from the original script shown above:
 *
 *    - All $.extends that add functionality to epi.EPiServer.Forms are lost.
 *
 *    - All styles and scripts that are added by /Util/EPiServer.Forms/EPiServerForms.js are (re)added resulting in duplicate script/style elements.
 *
 *    - All existing forms that have been previously initialized, are (re)initialized resulting in duplicate event handlers attached to form/input elements.
 *      2025-01-28: The duplicate event handlers issue has not been resolved.
 *
 *
 * @param formModel The form model to be used for fallback viewModeJs script.
 */
function initViewMode(formModel: FormModel) {
  //@ts-ignore
  const epi: EPiServerGlobal = window.epi
  if (epi.EPiServer?.Forms == null) {
    return
  }

  // Determine whether or not view mode (script) has ran.
  // Confirm this is necessary: Yes, it is possible for the script to be available but .init will not be available until the script has ran.
  const viewModeCreated = !!epi.EPiServer.Forms.init

  // Determine whether or not view mode (script) has initialized;
  // Note that this may or may not have been set by the specific viewmode script located in the previous lines as this script may be potentially imported in multiple places.
  const viewModeInitialized = viewModeCreated && !!epi.EPiServer.Forms.__Initialized

  // If we've alraedy initialized, re-init.
  if (viewModeInitialized) {
    // Execute form viewmode script. We must set window.epi.EPiServer.Forms.__Initialized = false here otherwise
    // in case page has two or more forms, the second form's viewmode script will not be called.
    epi.EPiServer.Forms.__Initialized = undefined
    //@ts-ignore
    epi.EPiServer.Forms.init()
  } else {
    // Locate existing EPiServerForms.js/EPiServerForms.min.js script.
    const viewModeScriptRegex = /\/Util\/EPiServer.Forms\/EPiServerForms[\.min]*\.js$/im
    const viewModeScript = [...document.getElementsByTagName('script')].find((script) => {
      const src = script.getAttribute('src')
      return src && viewModeScriptRegex.test(src)
    })

    // If script is NOT present, fallback to formModel script.
    if (!viewModeScript) {
      // Execute form viewmode script. We must set window.epi.EPiServer.Forms.__Initialized = false here otherwise
      // in case page has two or more forms, the second form's viewmode script will not be called.
      window.epi.EPiServer.Forms.__Initialized = undefined
      window.eval(formModel.assets.viewModeJs)

      // Executing the above reverts changes made by external scripts, reload external scripts.
      //
      // MBIDXP-205: Form Element | Console Errors - Bad Request and Fail to Execute.
      // Form element's may include additional script resources that may need to (re)execute following the above formModel.assets evals.
      // Specifically, scripts that $.extend or override epi.EPiServer.Forms (e.g. EPiServer.Forms.Samples\4.2.4\ClientResources\ViewMode\js\EPiServerFormsSamples.js)
      // may need to execute again following eval(formModel.assets.viewModeJs);
      reloadExternalScriptSources()
    }
  }
}

function initAnimationForm() {
  var container = document.getElementById('animateSuccess-js')
  if (!container) {
    return false
  }
  var forms = container.querySelectorAll('.EPiServerForms')

  forms.forEach((item) => {
    var submitBtn = item.querySelector('button[type="submit"]')
    var message = item.querySelector('.Form__Status__Message')

    if (submitBtn) {
      submitBtn.addEventListener('click', () => {
        setTimeout(() => {
          if (!message.classList.contains('hide')) {
            message.classList.add('hide')
          }
        }, 3000)
      })
    }
  })
}

function reloadExternalScriptSources() {
  var externalScriptSources = window.epi?.EPiServer?.Forms?.ExternalScriptSources
  if (Array.isArray(externalScriptSources)) {
    for (var externalScriptSource of externalScriptSources) {
      var src = String(externalScriptSource)
      if (src.includes('://')) {
        continue
      }
      var script = document.querySelector(`script[src="${src}"]`)
      if (script) {
        var reload = document.createElement('script')
        reload.src = src
        script.parentNode?.replaceChild(reload, script)
      }
    }
  }
}
